const AuthRoutes = {
  sendOtp: 'send_otp',
  sendEmailOtp: 'send_email_otp',
  sendWhatsAppOtp: 'send_whatsapp_otp',
  verifyOtp: 'verify_otp',
  register: 'register',
  getUserTypes: 'getUserTypes',
  getMembershipPlan: 'getMemberShipPlanByUserTypeId/',
  checkEmailPhone: 'checkEmailAndPassword/',
  login: 'login',
  logout: 'logout',
};

export default AuthRoutes